import request from '@/utils/request'
import Vue from 'vue'

//  类型列表
export function getTypeList(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/priceQuotation/getTypeList',
        params
    })
}

// 价格行情列表
export function getPriceQuotationListPage(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/priceQuotation/getPriceQuotationListPage',
        params
    })
}


// 价格行情走势详情
export function getMovementsDetails(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/priceQuotation/getMovementsDetails',
        params
    })
}

// 茶青价格预警
export function getCqPriceWarningData(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.dataCenterUrl + '/tea-green-variety-price/getTeaGreenPriceWarning',
        params

    })
}

// 茶青价格指数
export function getCqPriceIndexData(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.dataCenterUrl + '/tea-price-index/getTeaPriceIndexData',
        params
    })
}

// 茶青价格指数分析报告
export function indexReportSelectListByPage(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.dataCenterUrl + '/tea-price-index-report/selectListByPage',
        data
    })
}

